import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

type TransformType = ReturnType<CurrencyPipe['transform']>;
type CurrencyCodeType = Parameters<CurrencyPipe['transform']>[1];

const CRYPTO_SYMBOLS: Record<string, string> = {
  BTC: '₿',
  ETH: 'Ξ',
  SOL: '◎',
};

@Pipe({
  name: 'amount',
  standalone: true,
})
export class AmountPipe extends CurrencyPipe implements PipeTransform {
  private decimalPipe = new DecimalPipe('en-US');

  override transform(value?: number | string, currencyCode?: CurrencyCodeType): TransformType;

  override transform(value?: null | undefined, currencyCode?: CurrencyCodeType): null;

  override transform(value: number | string | null | undefined, currencyCode?: CurrencyCodeType): TransformType {
    // Handle crypto currencies with custom symbols
    if (currencyCode && CRYPTO_SYMBOLS[currencyCode]) {
      if (value === null || value === undefined) {
        return null;
      }
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      const formattedValue = this.decimalPipe.transform(numValue, '1.2-8');
      return `${CRYPTO_SYMBOLS[currencyCode]} ${formattedValue}`;
    }

    // Handle fiat currencies normally
    const currencyFormat = super.transform(value, currencyCode, 'symbol-narrow');
    if (!currencyFormat) {
      return currencyFormat;
    }

    return `${currencyFormat.charAt(0)} ${currencyFormat.slice(1)}`;
  }
}
